import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/diamond-ui/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/styles/tokens.css");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/diamond-ui/src/components/DaoVotingPhaseNotice/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/diamond-ui/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/src/components/Header/Header.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/diamond-ui/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/src/components/InfoTooltip/InfoTooltip.css");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/src/components/PrivacyModeIndicator/PrivacyModeIndicator.css");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/src/components/MarkdownText/MarkdownText.css");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/src/components/PrivacyModeGuard.css");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Archivo\",\"arguments\":[{\"variable\":\"--font-archivo\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"archivo\"}");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Spline_Sans_Mono\",\"arguments\":[{\"variable\":\"--font-mono\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"splineSansMono\"}");
;
import(/* webpackMode: "eager" */ "/app/diamond-ui/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/diamond-ui/src/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/diamond-ui/src/components/WebMCP/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DaoContextProvider"] */ "/app/diamond-ui/src/contexts/DAO/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrivacyModeProvider"] */ "/app/diamond-ui/src/contexts/PrivacyMode/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RuntimeConfigProvider"] */ "/app/diamond-ui/src/contexts/RuntimeConfig/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StakingContextProvider"] */ "/app/diamond-ui/src/contexts/Staking/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WalletConnectProvider"] */ "/app/diamond-ui/src/contexts/WalletConnect/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Web3ContextProvider"] */ "/app/diamond-ui/src/contexts/Web3/index.tsx");
